module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2SlwW"))).then(() => parcelRequire('d0iPb'));